import type { NotificationSubscription } from 'owa-notification';
import type { ProjectId } from 'owa-timestream-types';
import type AssetSubscriptionInfo from './AssetSubscriptionInfo';

const subscriptions: { [subscriptionId: string]: AssetSubscriptionInfo } = {};

export function addAssetSubscription(
    subscriptionId: string,
    projectId: ProjectId,
    notificationSubscription: NotificationSubscription
) {
    subscriptions[subscriptionId] = {
        whenCreated: new Date(),
        projectId,
        notificationSubscription,
    };
}

export function removeAssetSubscription(subscriptionId: string) {
    const info = subscriptions[subscriptionId];
    delete subscriptions[subscriptionId];
    return info;
}

export default function getAssetSubscription(subscriptionId: string) {
    return subscriptions[subscriptionId];
}
